import { Pipe, PipeTransform } from '@angular/core';
import { MedicamentoType} from "@core/models/Enums/medicamento-type.enum";

@Pipe({
  name: 'medicamentoTypeLabel',
  standalone: true,
})
export class MedicamentoTypeLabelPipe implements PipeTransform {

  transform(value: MedicamentoType | string | null | undefined): string {
    if (!value) return '';

    switch (value) {
      case MedicamentoType.PACKAGE:
        return 'PAQUETE';

      case MedicamentoType.UNIT:
        return 'UNIDAD';

      case MedicamentoType.SERVICE:
        return 'SERVICIO';

      case MedicamentoType.PRODUCT:
        return 'PRODUCTO';

      default:
        // Si llega algo nuevo del backend que no contemplaste, lo muestra tal cual
        return String(value);
    }
  }

}
